import React from 'react';
import { style as imageStyle, url as imageUrl } from 'utils/image';

import './exhibitor-card.scss';

interface ExhibitorInfo {
  id: number;
  name: string;
  short_name?: string;
  logo?: string;
  exhibitor_logo?: string;
  booth?: string;
  description?: string;
  contact_person?: string;
  contact_person_mobile?: string;
  banner?: string;
  [key: string]: any;
}

interface ExhibitorConfig {
  banner?: string;
  search?: boolean;
  showList?: boolean;
  autoShowAll?: boolean;
  list?: any[];
  exhibitorOrder?: number[];
}

const parseWindowJSON = (key: string) => {
  const val = (window as any)[key];
  if (!val) return null;
  if (typeof val === 'string') {
    try {
      return JSON.parse(val);
    } catch {
      return null;
    }
  }
  return val;
};

const ExhibitorCard: React.FC<any> = () => {
  const exhibitorInfo: ExhibitorInfo | null = parseWindowJSON('exhibitorInfo');
  const exhibitorConfig: ExhibitorConfig =
    parseWindowJSON('exhibitorConfig') || {};

  if (!exhibitorInfo) return null;

  const {
    name,
    short_name,
    exhibitor_logo,
    logo,
    booth,
    desc,
    contact_person_mobile,
  } = exhibitorInfo;
  // banner 优先使用 CRM 配置中的 banner，其次用展商自身的 banner
  const bannerKey =
    exhibitorInfo.gallery_pagedata_banner || exhibitorConfig.banner || '';
  const bannerSrc = bannerKey ? imageStyle(bannerKey, 'limit', { w: 750 }) : '';
  const logoKey =
    exhibitor_logo || logo || 'attachment/81bf55a022160f623df1988a2c7322e0.png';
  const logoSrc = logoKey
    ? imageUrl(logoKey, {
        'x-oss-process':
          'image/resize,m_pad,w_400,h_400,color_ffffff/format,jpg',
      })
    : null;

  const handleContact = () => {
    if (contact_person_mobile) {
      window.location.href = `tel:${contact_person_mobile}`;
    }
  };

  const placeholderText = '展'.substring(0, 1);

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    }
  };

  return (
    <>
      <div className="exhibitor-card-component">
        {/* Banner 区域 */}
        <div className="exhibitor-banner">
          {bannerSrc ? (
            <img src={bannerSrc} alt="" />
          ) : (
            <div className="banner-placeholder" />
          )}
        </div>

        {/* Logo 悬浮在 banner 底部 */}
        <div className="exhibitor-logo-wrap">
          <div className="exhibitor-logo container">
            {logoSrc ? (
              <img src={logoSrc} alt={name} className="caowei" />
            ) : (
              <span className="logo-placeholder">{placeholderText}</span>
            )}
          </div>
        </div>

        {/* 信息卡片 */}
        <div className="exhibitor-info-card">
          <div className="exhibitor-card-name">{name}</div>
          <div className="exhibitor-card-row">
            {booth && (
              <span className="exhibitor-card-booth">展位：{booth}</span>
            )}
            {contact_person_mobile && (
              <span className="exhibitor-card-contact" onClick={handleContact}>
                <span className="contact-icon">📞</span>
                <span>联系展商</span>
              </span>
            )}
          </div>
          {desc && <div className="exhibitor-card-desc">{desc}</div>}
        </div>
      </div>

      {/* 返回按钮 */}
      <div className="exhibitor-back-btn" onClick={handleBack}>
        <span className="back-icon">‹</span>
        <span>返回展商列表</span>
      </div>
    </>
  );
};

export default ExhibitorCard;
